<template>
  <td
    v-if="item && item.clientId != 0"
    id="program-table-inner"
    :colspan="headers.length"
    class="py-4"
    :class="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? 'px-0' : 'px-6'"
  >
    <div class="d-flex full-width">
      <!-- Left column with participant info -->
      <v-col :cols="6" class="d-flex flex-column justify-space-between">
        <div>
          <!-- Div for each of the participation data points -->
          <!-- Total Participants -->
          <div class="d-flex align-center py-1">
            <v-col :cols="2" class="px-0">
              <v-icon
                v-if="item.totalParticipants && item.totalParticipants.length"
                :color="offBrandCyan"
                @click="$emit('message-program-audience', item, 'everyone')"
                >mdi-email-outline</v-icon
              >
            </v-col>
            <v-col :cols="5" class="pl-0 pr-3 d-flex justify-space-between">
              <p class="mb-0">Participants</p>
              <span class="font-weight-black">{{
                item.totalParticipants ? item.totalParticipants.length : 0
              }}</span>
            </v-col>
            <!-- This is always going to be 100% -->
            <v-col :cols="5" class="px-0">
              <v-progress-linear
                class="mb-1"
                color="mediumGrey"
                value="100"
                buffer-value="100"
                height="14"
              ></v-progress-linear>
            </v-col>
          </div>
          <!-- Not Started -->
          <div class="d-flex align-center py-1">
            <v-col :cols="2" class="px-0">
              <v-icon
                v-if="item.notStartedParticipants && item.notStartedParticipants.length"
                :color="offBrandCyan"
                @click="$emit('message-program-audience', item, 'notStarted')"
                >mdi-email-outline</v-icon
              >
            </v-col>
            <v-col :cols="5" class="pl-0 pr-3 d-flex justify-space-between">
              <p class="mb-0">Not started</p>
              <span class="font-weight-black">{{
                item.notStartedParticipants ? item.notStartedParticipants.length : 0
              }}</span>
            </v-col>
            <v-col :cols="5" class="px-0">
              <v-progress-linear
                class="mb-1"
                color="brandYellow"
                :value="
                  calculatePercentage(
                    item.notStartedParticipants ? item.notStartedParticipants.length : 0,
                    item.totalParticipants ? item.totalParticipants.length : 0
                  )
                "
                buffer-value="100"
                height="14"
              ></v-progress-linear>
            </v-col>
          </div>
          <!-- In Progress -->
          <div class="d-flex align-center py-1">
            <v-col :cols="2" class="px-0">
              <v-icon
                v-if="item.inProgressParticipants && item.inProgressParticipants.length"
                :color="offBrandCyan"
                @click="$emit('message-program-audience', item, 'started')"
                >mdi-email-outline</v-icon
              >
            </v-col>
            <v-col :cols="5" class="pl-0 pr-3 d-flex justify-space-between">
              <p class="mb-0">In progress</p>
              <span class="font-weight-black">{{
                item.inProgressParticipants ? item.inProgressParticipants.length : 0
              }}</span>
            </v-col>
            <v-col :cols="5" class="px-0">
              <v-progress-linear
                class="mb-1"
                :color="offBrandCyan"
                :value="
                  calculatePercentage(
                    item.inProgressParticipants ? item.inProgressParticipants.length : 0,
                    item.totalParticipants.length
                  )
                "
                buffer-value="100"
                height="14"
              ></v-progress-linear>
            </v-col>
          </div>
          <!-- Completed -->
          <div class="d-flex align-center py-1">
            <v-col :cols="2" class="px-0">
              <v-icon
                v-if="item.completedParticipants && item.completedParticipants.length"
                :color="offBrandCyan"
                @click="$emit('message-program-audience', item, 'complete')"
                >mdi-email-outline</v-icon
              >
            </v-col>
            <v-col :cols="5" class="pl-0 pr-3 d-flex justify-space-between">
              <p class="mb-0">Completed</p>
              <span class="font-weight-black">{{
                item.completedParticipants ? item.completedParticipants.length : 0
              }}</span>
            </v-col>
            <v-col :cols="5" class="px-0">
              <v-progress-linear
                class="mb-1"
                :color="offBrandBrightGreen"
                :value="
                  calculatePercentage(
                    item.completedParticipants ? item.completedParticipants.length : 0,
                    item.totalParticipants.length
                  )
                "
                buffer-value="100"
                height="14"
              ></v-progress-linear>
            </v-col>
          </div>
        </div>
        <!-- Start and end date (if program has it) -->
        <div class="d-flex justify-space-between mt-4 py-1">
          <p class="my-0" v-show="item.formattedStartDate">Start: {{ item.formattedStartDate }}</p>
          <p class="my-0" v-if="item.formattedEndDate" v-show="item.formattedEndDate">
            End: {{ item.formattedEndDate }}
          </p>
          <p class="my-0" v-else v-show="item.formattedRollingProgram">
            Rolling: {{ item.formattedRollingProgram }}
          </p>
        </div>
      </v-col>
      <v-col :cols="6" class="d-flex flex-column justify-space-between">
        <div class="d-flex" :class="$vuetify.breakpoint.mdAndDown ? 'flex-column' : ''">
          <v-col :cols="6" class="d-flex flex-column justify-space-between">
            <div class="flex-column justify-start">
              <!-- Program action buttons -->
              <v-btn
                class="d-flex align-center pr-2 pl-0 program-action-button"
                text
                @click="$emit('load-program-wizard', item, true)"
              >
                <v-icon :color="offBrandCyan" v-if="item.status != 'Deleted'">mdi-pencil</v-icon>
                <p class="mb-0">Edit Program</p>
              </v-btn>
              <v-btn
                class="d-flex align-center pr-2 pl-0 program-action-button"
                text
                @click="$emit('load-program-wizard', item, false)"
              >
                <v-icon :color="offBrandCyan">mdi-content-copy</v-icon>
                <p class="mb-0">Duplicate Program</p>
              </v-btn>
              <v-tooltip top :disabled="!disableDeleteButton(item)" open-delay="200">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="d-flex align-center pr-2 pl-0 program-action-button"
                    text
                    v-on="on"
                    v-bind="attrs"
                    :disabled="disableDeleteButton(item)"
                    @click="$emit('delete-program-confirmation', item)"
                  >
                    <v-icon
                      :color="offBrandCyan"
                      :loading="item.programId == displayLoadingIconOnProgram"
                      >mdi-trash-can-outline</v-icon
                    >
                    <p class="mb-0">Delete Program</p>
                  </v-btn>
                </template>
                <span v-if="disableDeleteButton(item)">
                  You do not have permission to delete this program
                </span>
              </v-tooltip>
            </div>
          </v-col>
          <v-col :cols="6">
            <div>
              <v-btn
                class="d-flex align-center pr-2 pl-0 program-action-button"
                text
                v-if="item.status == 'Active' && item.nonLearningMetrics === true"
                @click="$emit('load-metric-ui', item.programId)"
              >
                <v-icon
                  :color="offBrandCyan"
                  :disabled="item.status != 'Active' || item.nonLearningMetrics == false"
                  >mdi-checkbox-marked-outline</v-icon
                >
                <p class="mb-0">Update Progress</p>
              </v-btn>
              <!-- Can't add participants in the program builder to an active program -->
              <v-tooltip
                top
                open-delay="200"
                :disabled="item.complexProgram != true || item.status !== 'Active'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="d-flex align-center pr-2 pl-0 program-action-button"
                    text
                    v-on="on"
                    v-bind="attrs"
                    @click="$emit('load-program-wizard', item, true, 'participants')"
                  >
                    <v-icon
                      :color="offBrandCyan"
                      :disabled="item.complexProgram == true && item.status == 'Active'"
                      >mdi-account-multiple-plus</v-icon
                    >
                    <p class="mb-0">Add Participants</p>
                  </v-btn>
                </template>
                <span
                  >Contact your client success manager to add participants to this program
                </span>
              </v-tooltip>
            </div>
          </v-col>
        </div>
        <div class="d-flex flex-column py-1" v-if="item.budgetId && budgets[item.budgetId]">
          <p class="mb-0" v-if="budgets[item.budgetId].errorFetching == true">
            Error getting program budget
          </p>
          <div v-else>
            <p class="mb-0">Budget available</p>
            <!-- loading -->
            <div v-if="budgets[item.budgetId].loading == true">
              <v-progress-linear
                indeterminate
                :color="offBrandCyan"
                class="mt-3 mb-3"
              ></v-progress-linear>
            </div>
            <!-- If only current total but not original funded amount, display current total -->
            <p
              class="mb-0"
              v-else-if="
                budgets[item.budgetId].originalFundedAmount === undefined ||
                budgets[item.budgetId].originalFundedAmount === null
              "
            >
              {{ budgets[item.budgetId].formattedCurrentBudgetBalance }}
            </p>
            <div class="d-flex mt-1" v-else>
              <p class="mb-0 mr-3 font-weight-black">
                {{ budgets[item.budgetId].formattedCurrentBudgetBalance }}
              </p>
              <v-progress-linear
                class="mb-1"
                :color="offBrandBrightGreen"
                background-color="mediumGrey"
                :value="
                  (Number(budgets[item.budgetId].currentBudgetBalance) /
                    Number(budgets[item.budgetId].originalFundedAmount)) *
                  100
                "
                buffer-value="100"
                height="14"
              ></v-progress-linear>
              <p class="mb-0 ml-3">
                {{ budgets[item.budgetId].formattedOriginalFundedAmount }}
              </p>
            </div>
          </div>
        </div>
      </v-col>
    </div>
  </td>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ProgramAdminExpansion",
  props: {
    item: {
      type: Object,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    budgets: {
      type: Object,
      default: () => ({}),
    },
    displayLoadingIconOnProgram: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    ...mapState(["permissions", "globalClientId", "userProfile"]),
    clientId() {
      return this.globalClientId;
    },
    // Colors - Chris is using not brand colors in the wireframes
    offBrandCyan() {
      return "#4DC9F9";
    },
    offBrandBrightGreen() {
      return "#A2D76D";
    },
  },
  methods: {
    calculatePercentage(part, total) {
      if (total === 0) return 0;
      return (part / total) * 100;
    },
    disableDeleteButton(item) {
      if (
        (item.status == "Archived" && this.userProfile.clientId != 1) ||
        !this.permissions.includes("programs:delete:program") ||
        (item.clientId != this.clientId && this.userProfile.clientId != 1)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.program-action-button {
  letter-spacing: 0;
  text-transform: none;
  line-height: 1.5;
  font-size: 16px;
  justify-content: flex-start;
  padding-left: 0 !important;
}

.program-action-button p {
  margin-left: 8px;
}

/* Decreases padding in the table's expanded content */
#program-table-inner >>> .col {
  padding-top: 4px;
  padding-bottom: 4px;
}

/* Adds padding to the right of inner table icons */
#program-table-inner >>> .v-icon {
  padding-right: 6px;
}
</style>
